module.exports = __webpack_public_path__ + "static/img/product-2.ccc3c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/product-2.png
// module id = fcoC
// module chunks = 49